module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_29.dot-3b1c68a94b29c13eb21a46840e0aec3a.svg";